export const hotkeys = {
  toggleBoardEdit: "mod+e",
  toggleColorScheme: "mod+j",
  saveNotebook: "mod+s",
  openSpotlight: "mod+k",
};
